import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Skyline from "../components/Skyline";

export default function FinalCta() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-40">
      <Reveal>
        <div className="rounded-3xl bg-[#fafafa] border border-black/5 px-8 md:px-20 py-20 md:py-28 text-center relative overflow-hidden">
          <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center opacity-[0.06]">
            <Skyline animate={false} className="w-[420px] h-40" />
          </div>
          <h2 className="font-display text-4xl md:text-7xl tracking-tighter font-medium leading-[0.95] max-w-3xl mx-auto">
            Get your time back.
          </h2>
          <Link to="/book-demo" className="mt-12 inline-flex items-center gap-2 rounded-full bg-[#0a0a0a] text-white px-9 py-4 text-lg transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-xl" data-testid="cta-book-demo">
            Book a discovery call <ArrowUpRight size={20} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
